import template from './templates/tab-directive.tpl.html';

class TabController {

  static get $inject() {
    return ['$translate', '$compile'];
  }

  constructor($translate, $compile) {
    this.$translate = $translate;
    this.$compile = $compile;
  }

  initialize(transclude) {
    this.transclude = transclude;

    if (this.heading) {
      this.$translate(this.heading)
        .then(heading => this.heading = heading)
        .catch(heading => this.heading = heading);
    }

    this.stateParams = this.stateParams || {};
    this.stateOptions = this.stateOptions || {};

    this.transclude((clone, scope) => {
      this.transcludeClone = clone;
      this.transcludeScope = scope;
    });
    this.headerTemplate = false;
  }

  transcludeHeader(parentScope, headerElem, headerTemplate) {
    headerTemplate = headerTemplate.trim();
    //just in case developer does not pass valid html
    if (headerTemplate.charAt(0) !== '<') {
      headerTemplate = `<span>${headerTemplate}</span>`;
    }
    headerElem.find('a')
      .empty()
      .append(this.$compile(headerTemplate)(parentScope));
  }
}

export default function() {

  return {
    restrict: 'E',
    require: '^akamTabs',
    transclude: true,
    replace: true,
    scope: {},
    bindToController: {
      heading: '@?',
      state: '@',
      stateParams: '=?',
      stateOptions: '=?',
      active: '=?',
      disabled: '=?',
      icon: '@?'
    },
    controller: TabController,
    controllerAs: 'tab',
    template,
    link(scope, elem, attrs, tabs, transclude) {
      const tab = scope.tab;

      tab.initialize(transclude);

      if (attrs.headerTemplate !== undefined && attrs.headerTemplate.trim()) {
        tab.transcludeHeader(scope.$parent, elem, attrs.headerTemplate);
        tab.headerTemplate = true;
      }

      tab.activate = () => tabs.activate(tab);

      tabs.addTab(tab);
    }
  };
}
